import { render, staticRenderFns } from "./SamlSettingPageDemo.vue?vue&type=template&id=43c63608&scoped=true"
import script from "./SamlSettingPageDemo.vue?vue&type=script&lang=ts&setup=true"
export * from "./SamlSettingPageDemo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SamlSettingPageDemo.vue?vue&type=style&index=0&id=43c63608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c63608",
  null
  
)

export default component.exports